import { Skeleton } from '@/shared/components/ui/skeleton'
import { cn } from '@/shared/lib/utils'

export function ChatMessagesSkeleton({ className }: { className?: string }) {
  return (
    <div className={cn('flex flex-col gap-2 space-y-6', className)}>
      {/* Agent message skeleton */}
      <div className="mr-auto flex flex-col items-start gap-2.5">
        {/* Agent icon skeleton */}
        <div className="flex items-start gap-2.5">
          <Skeleton className="size-[19px] shrink-0 rounded-full bg-grey-03" />
          <div className="flex max-w-[600px] flex-col gap-2">
            <Skeleton className="h-4 w-80 bg-grey-03" />
            <Skeleton className="h-4 w-96 bg-grey-03" />
            <Skeleton className="h-4 w-64 bg-grey-03" />
          </div>
        </div>
      </div>

      {/* User message skeleton */}
      <div className="ml-auto max-w-[460px]">
        <Skeleton className="h-12 w-48 rounded-lg bg-grey-03" />
      </div>

      {/* Agent message skeleton */}
      <div className="mr-auto flex flex-col items-start gap-2.5">
        <div className="flex items-start gap-2.5">
          <Skeleton className="size-[19px] shrink-0 rounded-full bg-grey-03" />
          <div className="flex max-w-[600px] flex-col gap-2">
            <Skeleton className="h-4 w-72 bg-grey-03" />
            <Skeleton className="h-4 w-80 bg-grey-03" />
          </div>
        </div>
      </div>

      {/* User message skeleton */}
      <div className="ml-auto max-w-[460px]">
        <Skeleton className="h-16 w-64 rounded-lg bg-grey-03" />
      </div>

      {/* Agent message skeleton */}
      <div className="mr-auto flex flex-col items-start gap-2.5">
        <div className="flex items-start gap-2.5">
          <Skeleton className="size-[19px] shrink-0 rounded-full bg-grey-03" />
          <div className="flex max-w-[600px] flex-col gap-2">
            <Skeleton className="h-4 w-60 bg-grey-03" />
            <Skeleton className="w-88 h-4 bg-grey-03" />
            <Skeleton className="h-4 w-44 bg-grey-03" />
          </div>
        </div>
      </div>
    </div>
  )
}
